import PropTypes from 'prop-types';
import Feature from 'ol/Feature';
import singleContactPropTypes from 'client/pages/MapPage/components/MapMenu/ContactDetails/SingleContact/SingleContactPropTypes';

const types = {
    feature: PropTypes.instanceOf(Feature),
    nuarActor: PropTypes.object,
    contacts: PropTypes.shape({
        emergency: PropTypes.arrayOf(PropTypes.shape(singleContactPropTypes)),
        business: PropTypes.arrayOf(PropTypes.shape(singleContactPropTypes))
    }),
    sensitiveAssetData: PropTypes.object,
    styleId: PropTypes.string,
    layerName: PropTypes.string,
    assetName: PropTypes.string
};

export default types;
